import { useEffect, useState } from 'react';
import { db } from './firebase';
import { ref, set, onDisconnect, onValue, remove } from 'firebase/database';

export default function useRealtimePresence(user) {
  const [activeUsers, setActiveUsers] = useState([]);

  useEffect(() => {
    if (!user) return;
    const sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    const presenceRef = ref(db, `presence/${sessionId}`);

    set(presenceRef, {
      email: user.email.toLowerCase(),
      name: user.name,
      timestamp: Date.now()
    });

    onDisconnect(presenceRef).remove();

    // Listen for all presence
    const allPresenceRef = ref(db, 'presence');
    const unsubscribe = onValue(allPresenceRef, (snapshot) => {
      const data = snapshot.val() || {};
      setActiveUsers(Object.values(data));
    });

    return () => {
      remove(presenceRef);
      unsubscribe();
    };
  }, [user]);

  return activeUsers;
} 